import { withInstall } from '@mts-fe/utils';
import _NowTime from './NowTime.vue';

export const NowTime = withInstall(_NowTime);
